import {
  MagnifyingGlass,
  ArrowClockwise,
  X,
  File,
} from '@phosphor-icons/react';
import { MoonLoader } from 'react-spinners';
import { ArtilleryReport } from '@Models/types';
import React from 'react';

interface ArtillerySidebarProps {
  reports: ArtilleryReport[] | null;
  singleReport: ArtilleryReport | null;
  setSingleReport: (report: ArtilleryReport) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  fetchReports: () => void;
  isRefreshing: boolean;
}

const formatDate = (timestamp: string) => {
  const date = new Date(Number(timestamp));
  return date.toLocaleDateString('en-GB');
};

const ArtillerySidebar: React.FC<ArtillerySidebarProps> = ({
  reports,
  singleReport,
  setSingleReport,
  searchTerm,
  setSearchTerm,
  fetchReports,
  isRefreshing,
}) => (
  <div className="flex h-full w-1/5 flex-col gap-1 rounded-xl border p-4 shadow-md">
    <span className="flex justify-between">
      <h2 className="text-lg font-bold">Reports</h2>
      <button
        onClick={fetchReports}
        disabled={isRefreshing}
        className="flex flex-row items-center gap-1 rounded-md bg-primary-700 p-2 text-xs text-white disabled:bg-gray-400"
      >
        {isRefreshing ? (
          <MoonLoader color="white" size={10} />
        ) : (
          <ArrowClockwise size={16} weight="bold" />
        )}
        {isRefreshing ? 'Refreshing...' : 'Refresh  '}
      </button>
    </span>
    <div className="mt-2 flex flex-row items-center gap-x-2 rounded-md border px-4 py-2">
      <MagnifyingGlass size={20} weight="bold" />
      <input
        type="text"
        className="w-full border-gray-300 font-inter text-xs focus:outline-none sm:text-sm"
        placeholder={`Search reports`}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <X
        weight="bold"
        className="cursor-pointer hover:text-brandRed-500"
        onClick={() => setSearchTerm('')}
      />
    </div>
    <div className="flex h-full flex-col overflow-y-auto">
      {isRefreshing ? (
        <span className="flex h-full w-full flex-col items-center justify-center sm:gap-y-6 sm:p-5">
          <MoonLoader color="#071D49" size={100} />
          <span className="animate-pulse text-xs font-semibold tracking-wide text-gray-600 sm:text-sm">
            Fetching Reports
          </span>
        </span>
      ) : (
        reports &&
        (Array.isArray(reports) && reports.length > 0 ? (
          reports
            .filter((report) =>
              report.reportName.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((report) => (
              <button
                key={report.executiveSummary.testDate}
                onClick={() => setSingleReport(report)}
                className={`text-md border-b p-3 text-start font-semibold transition-colors duration-200 hover:bg-slate-300 ${singleReport?.reportName === report.reportName && 'bg-slate-300'}`}
              >
                <div className="flex flex-col">
                  <span className="font-semibold">{report.reportName}</span>
                  <span className="text-xs text-gray-500">
                    {formatDate(report.executiveSummary.testDate)}
                  </span>
                </div>
              </button>
            ))
        ) : (
          <div className="flex h-full w-full flex-col items-center justify-center text-gray-500">
            <File size={48} />
            <span className="text-sm font-medium">No reports available</span>
          </div>
        ))
      )}
    </div>
  </div>
);

export default ArtillerySidebar;
